import React from "react";
import { BrowserRouter as Router, Route, useParams } from "react-router-dom";
import Pages from "pages";

import "normalize.css";
import GlobalStyles from "./GlobalStyles";
import GlobalContext from "./GlobalContext";

import ApolloClient from "apollo-boost";
import { ApolloProvider } from "@apollo/react-hooks";

function App() {
  return (
    <Router>
      <Route path="/:lang?" component={Main} />
    </Router>
  );
}

function Main() {
  const { lang } = useParams();
  const langPrefix = lang && lang === "en" ? "/en" : "";
  const client = new ApolloClient({
    // Same origin: nginx proxies /graphql (and /en/graphql) to WordPress.
    // Calling admin.amadeusonline.org directly made every request a
    // cross-origin one, which broke the day wp-graphql changed its CORS
    // headers.
    uri: langPrefix + "/graphql",
  });
  return (
    <ApolloProvider client={client}>
      <GlobalContext>
        <GlobalStyles />
        <div className="App">
          <Pages />
        </div>
      </GlobalContext>
    </ApolloProvider>
  );
}

export default App;
